"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UitpasApiService = exports.API_ERROR_CODES = void 0;
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var Observable_1 = require("rxjs/Observable");
exports.API_ERROR_CODES = {
    'UNKNOWN_GROUPPASS': "Dit UiTPas-nummer is geen groepspas."
};
var UitpasApiService = /** @class */ (function () {
    function UitpasApiService(http) {
        this.http = http;
    }
    UitpasApiService.prototype.getGroupPassInfo = function (uitpasNumber) {
        return this.http.get(process.env.API_URL + 'group-pass/' + uitpasNumber)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    UitpasApiService.prototype.handleError = function (error) {
        var message;
        var code;
        if (error instanceof http_1.Response) {
            var body = error.json() || '';
            if (body.code && exports.API_ERROR_CODES[body.code]) {
                message = exports.API_ERROR_CODES[body.code];
                code = body.code;
            }
            else {
                var err = body.error || JSON.stringify(body);
                message = "".concat(error.status, " - ").concat(error.statusText || '', " ").concat(err);
                code = '';
            }
        }
        else {
            if (error.code && exports.API_ERROR_CODES[error.code]) {
                message = exports.API_ERROR_CODES[error.code];
                code = error.code;
            }
            else {
                message = error.message ? error.message : error.toString();
                code = '';
            }
        }
        return Observable_1.Observable.throw({
            code: code,
            message: message
        });
    };
    UitpasApiService = __decorate([
        (0, core_1.Injectable)(),
        __metadata("design:paramtypes", [http_1.Http])
    ], UitpasApiService);
    return UitpasApiService;
}());
exports.UitpasApiService = UitpasApiService;
